import useSessionStore from 'Context/useSessionStore'
import TableUserTeamRow from './TableUserTeamRow'

const TableUserTeam = ({ users, setVisibleBudgetModal, onDelete, onSaveRate, billing, budget }) => {
  const { user: userContext } = useSessionStore((state) => ({ user: state.user }))

  const showMemberBudget = budget?.type === 'Fee per team member' || budget?.type === 'Hours per team member'
  const chargePerMember = billing?.method === 'Charge per team member'

  return (
    <div className='table-responsive'>
      <table className="table align-middle">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">Name</th>
            {showMemberBudget && <th scope="col">Budget</th>}
            <th scope="col">Cost Rate</th>
            {chargePerMember && <th scope="col">Billable Rate</th>}
            <th />
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <TableUserTeamRow
              key={user.id}
              user={user}
              billing={billing}
              budget={budget}
              userContext={userContext}
              setVisibleBudgetModal={setVisibleBudgetModal}
              onDelete={onDelete}
              onSaveRate={onSaveRate}
            />
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default TableUserTeam
